import React from 'react';

export default function OverviewTab({ stats, appointments, reviews, messages, t }) {
  const formatDate = (date) => { if (!date) return ''; const dateOnly = String(date).substring(0, 10); return new Date(dateOnly + 'T12:00:00').toLocaleDateString(); };
  const formatTime = (time) => time?.substring(0, 5);

  return (
    <div>
      <h2 style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: '2rem', color: '#D42B2B', marginBottom: '2rem' }}>{t.admin.recentActivity}</h2>

      <div style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '1rem', color: '#E8ECF0', marginBottom: '1rem', fontFamily: "'Barlow', sans-serif", letterSpacing: '0.1em' }}>
          {t.admin.latestAppts}
        </h3>
        <div style={{ background: '#111827', border: '1px solid rgba(148,163,184,0.15)', padding: '1.5rem' }}>
          {appointments.slice(0, 5).map(appt => (
              <div key={appt.id} style={{ padding: '1rem 0', borderBottom: '1px solid rgba(148,163,184,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ color: '#E8ECF0', marginBottom: '0.3rem' }}>{appt.first_name} {appt.last_name}</div>
                  <div style={{ fontSize: '0.8rem', color: '#94A3B8' }}>{Array.isArray(appt.services) && appt.services.length > 0
                    ? appt.services.map(s => s.name_fr || s.name).join(' + ')
                    : appt.service_name} • {formatDate(appt.appointment_date)} {t.dashboard.at} {formatTime(appt.appointment_time)}</div>
                </div>
                <span className={`badge badge-status-${appt.status}`} style={{ padding: '0.4rem 0.8rem', fontSize: '0.7rem', borderRadius: '3px' }}>
                  {t.dashboard.status?.[appt.status] || appt.status}
                </span>
              </div>
          ))}
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <h3 style={{ fontSize: '1rem', color: '#E8ECF0', marginBottom: '1rem', fontFamily: "'Barlow', sans-serif", letterSpacing: '0.1em' }}>
            {t.admin.recentReviews}
          </h3>
          <div style={{ background: '#111827', border: '1px solid rgba(148,163,184,0.15)', padding: '1.5rem' }}>
            {reviews.slice(0, 3).map(review => (
                <div key={review.id} style={{ padding: '1rem 0', borderBottom: '1px solid rgba(148,163,184,0.1)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                    <span style={{ color: '#E8ECF0' }}>{review.first_name} {review.last_name}</span>
                    <span style={{ color: '#D42B2B' }}>{'⭐'.repeat(review.rating)}</span>
                  </div>
                  {review.comment && <div style={{ fontSize: '0.85rem', color: '#94A3B8', fontStyle: 'italic' }}>"{review.comment.substring(0, 80)}..."</div>}
                </div>
            ))}
          </div>
        </div>

        <div className="col-md-6">
          <h3 style={{ fontSize: '1rem', color: '#E8ECF0', marginBottom: '1rem', fontFamily: "'Barlow', sans-serif", letterSpacing: '0.1em' }}>
            {t.admin.newMessages}
          </h3>
          <div style={{ background: '#111827', border: '1px solid rgba(148,163,184,0.15)', padding: '1.5rem' }}>
            {messages.filter(m => m.status === 'new').slice(0, 3).map(msg => (
                <div key={msg.id} style={{ padding: '1rem 0', borderBottom: '1px solid rgba(148,163,184,0.1)' }}>
                  <div style={{ color: '#E8ECF0', marginBottom: '0.3rem' }}>{msg.name}</div>
                  <div style={{ fontSize: '0.85rem', color: '#94A3B8' }}>{msg.subject}</div>
                </div>
            ))}
            {messages.filter(m => m.status === 'new').length === 0 && (
                <div style={{ color: '#94A3B8', fontSize: '0.9rem', textAlign: 'center', padding: '2rem' }}>{t.admin.noNewMessages}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
